import httpClient from "./index";

const END_POINT = "unit-models";

const floors = () => httpClient.get(END_POINT);

export { floors };
